export default {"src":"/_next/static/media/tac-logo.488a46aa.svg","height":28,"width":54,"blurWidth":0,"blurHeight":0};